import { render, staticRenderFns } from "./MyTeams.vue?vue&type=template&id=4e4b37be&scoped=true"
import script from "./MyTeams.vue?vue&type=script&lang=js"
export * from "./MyTeams.vue?vue&type=script&lang=js"
import style0 from "./MyTeams.vue?vue&type=style&index=0&id=4e4b37be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4b37be",
  null
  
)

export default component.exports